import type { IOrder, ISamplePool } from '../../../../Model/index.js'
import { buildSamplePoolCsvTable, poolCsvRowsToCsv } from './PoolCsvTable.ts'

export const downloadSamplePoolCSV = (order: IOrder, samplePools: ISamplePool[]) => {
  const { rows } = buildSamplePoolCsvTable(samplePools)
  const csv = poolCsvRowsToCsv(rows)
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `sample_pools_${order.id}.csv`)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
